import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { DetailModal, HospitalHeader } from '../index';
import styles from './index.less';
import { formateImageWebp } from '../../utils';
export var HospitalModal = function (_a) {
    var hospital = _a.hospital, show = _a.show, onHide = _a.onHide;
    var backgroundImage = hospital.backgroundImage, establishmentDate = hospital.establishmentDate, hospitalTypeName = hospital.hospitalTypeName, bedNumber = hospital.bedNumber, desc = hospital.desc, environment = hospital.environment;
    var _b = useComponents(), View = _b.View, Image = _b.Image;
    return (React.createElement(DetailModal, { title: '医院介绍', className: styles['hospital-detail-modal'], show: show, onHide: onHide, height: '50%' },
        React.createElement(HospitalHeader, { hospitalData: hospital, type: "block" }, backgroundImage && (React.createElement(Image, { className: styles['hospital-header-img'], src: formateImageWebp(backgroundImage), imageWidth: 75, imageHeight: 50 }))),
        React.createElement(View, { className: styles['hospital-info-tag'] },
            React.createElement(View, { className: styles['info-tag-item'] },
                establishmentDate,
                "\u5E74\u6210\u7ACB"),
            React.createElement(View, { className: styles['info-tag-item'] }, hospitalTypeName),
            bedNumber && React.createElement(View, { className: styles['info-tag-item'] },
                bedNumber,
                "\u4E2A\u5E8A\u4F4D")),
        React.createElement(View, { className: styles['hospital-desc'] }, desc),
        environment && environment.length > 0 && (React.createElement(View, { className: styles['hospital-environment'] },
            React.createElement(View, { className: styles['hospital-environment-title'] }, "\u533B\u9662\u73AF\u5883"),
            environment.map(function (img, index) { return (React.createElement(View, { className: styles['environment-image'], key: index },
                React.createElement(Image, { src: formateImageWebp(img), imageWidth: 74, imageHeight: 50 }))); })))));
};
